import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useIsMobile } from "@/hooks/use-mobile";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { MapPin, Route, Search, Plus, Users, Bookmark, Compass } from "lucide-react";
import { useI18n } from "@/lib/i18n";

interface HelpModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const sectionKeys = [
  { icon: Compass, titleKey: "help.whatIs.title", bodyKey: "help.whatIs.body" },
  { icon: Route, titleKey: "help.startTrip.title", bodyKey: "help.startTrip.body" },
  { icon: Search, titleKey: "help.search.title", bodyKey: "help.search.body" },
  { icon: MapPin, titleKey: "help.map.title", bodyKey: "help.map.body" },
  { icon: Plus, titleKey: "help.addStop.title", bodyKey: "help.addStop.body" },
  { icon: Users, titleKey: "help.share.title", bodyKey: "help.share.body" },
  { icon: Bookmark, titleKey: "help.favorites.title", bodyKey: "help.favorites.body" },
];

const HelpModal = ({ open, onOpenChange }: HelpModalProps) => {
  const isMobile = useIsMobile();
  const { t } = useI18n();

  const title = t("help.title");

  const content = (
    <div className="space-y-3 pb-2">
      {sectionKeys.map((s, i) => (
        <div key={i} className="flex gap-3 p-3 rounded-xl bg-muted/40 border border-border/30">
          <div className="shrink-0 w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center">
            <s.icon className="h-4.5 w-4.5 text-primary" />
          </div>
          <div className="min-w-0">
            <p className="font-semibold text-sm text-foreground">{t(s.titleKey)}</p>
            <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{t(s.bodyKey)}</p>
          </div>
        </div>
      ))}
    </div>
  );

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className="max-h-[85dvh]">
          <DrawerHeader>
            <DrawerTitle className="text-lg">{title}</DrawerTitle>
          </DrawerHeader>
          <div className="px-4 pb-6 overflow-y-auto" style={{ WebkitOverflowScrolling: "touch" }}>
            {content}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-lg">{title}</DialogTitle>
        </DialogHeader>
        {content}
      </DialogContent>
    </Dialog>
  );
};

export default HelpModal;
